var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css, } from "styled-components";
export var forBp = function (bp, content) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media only screen and (min-width: ", ") {\n      ", "\n    }\n  "], ["\n    @media only screen and (min-width: ", ") {\n      ", "\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.responsive[bp];
    }, content);
};
export var forPrint = function (content) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media only print {\n      ", "\n    }\n    .print & {\n      ", "\n    }\n  "], ["\n    @media only print {\n      ", "\n    }\n    .print & {\n      ", "\n    }\n  "])), content, content);
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=breakpoints.js.map